import React, { FC } from 'react';
import { TNavigationBarTabsDesktop } from '../types/navigationBar.types';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TStringField } from '../../../../types/sitecore.types';
import { googleNavClickEvent } from '../../../../utils/analytics';
import { sectionTab } from '../../../../constants/analytics.constants';

const NavigationBarTabsDesktop: FC<TNavigationBarTabsDesktop> = (props) => {
  const { tabs, activeTab, scrollToPlaceholder, isEditorial } = props;

  return (
    <ul className={'navigation-bar-container__tabs'}>
      {tabs?.map((tab, index) => (
        <li
          role={'listitem'}
          className={`navigation-bar-container__tab ${activeTab === index ? 'navigation-bar-container__tab--active' : ''} ${
            !tab?.isVisible ? 'navigation-bar-container__tab--hidden' : ''
          }`}
          key={tab?.label as string}
          onClick={(): void => {
            scrollToPlaceholder(index);
            googleNavClickEvent(sectionTab, '', tab?.label as string);
          }}
        >
          <Text
            tag="div"
            field={isEditorial ? (tab?.label as TStringField) : ({ value: tab?.label } as TStringField)}
            editable={isEditorial}
          />
        </li>
      ))}
    </ul>
  );
};

export default NavigationBarTabsDesktop;
